import React from 'react';

const switchToNextNode = (event: React.KeyboardEvent<HTMLInputElement>, switchStep: number) => {
  const form = event.currentTarget.form as HTMLFormElement;
  if (!form) return;

  const allElements = Array.from(form.elements) as HTMLElement[];

  const visibleElements = allElements.filter((el) => {
    const isDisabled = (el as HTMLInputElement).disabled;
    const isVisible = el.tabIndex !== -1 && el.offsetParent !== null;

    return !isDisabled && isVisible;
  });

  const index = visibleElements.indexOf(event.currentTarget);
  const next = visibleElements[index + switchStep];
  if (next) next.focus();
};

export const formUtils = {
  switchToNextNode,
};
